import { Box, Avatar, Typography, Menu, MenuItem } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProfileMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [user, setUser] = useState({ nombre: '', apellido: '' });
  const openMenu = Boolean(anchorEl);
  const navigate = useNavigate();

  useEffect(() => {
    const access = localStorage.getItem('access_token');
    let nombre = '';
    let apellido = '';
    let userId = null;
    if (access) {
      try {
        const base64Url = access.split('.')[1];
        if (base64Url) {
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const padded = base64 + '='.repeat((4 - base64.length % 4) % 4);
          const jsonPayload = decodeURIComponent(
            atob(padded)
              .split('')
              .map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
              })
              .join('')
          );
          const payload = JSON.parse(jsonPayload);

          nombre = payload.first_name || '';
          apellido = payload.last_name || '';
          userId = payload.user_id;
        }
      } catch (e) {
        console.error("Error decoding JWT:", e);
      }
    }

    if (nombre || apellido) {
      setUser({ nombre, apellido });
    } else if (access) {
      // Fetch user info from backend if not in token
      fetch('https://vhg.ar/flotapp/api/user/', { // or your backend URL
        headers: {
          Authorization: `Bearer ${access}`,
          Accept: 'application/json',
        },
      })
        .then(res => {
          if (!res.ok) {
            // Log the response text for debugging
            res.text().then(text => {
              console.error("Non-OK response from /api/user/:", res.status, text);
            });
            throw new Error(`HTTP ${res.status}`);
          }
          const contentType = res.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            return res.json();
          } else {
            // Log the response text for debugging
            res.text().then(text => {
              console.error("Not JSON response from /api/user/:", text);
            });
            throw new Error("Not JSON response");
          }
        })
        .then(data => {
          if (data) {
            setUser({
              nombre: data.first_name || '',
              apellido: data.last_name || ''
            });
          }
        })
        .catch(err => {
          console.error("Error fetching user info from /api/user/:", err);
        });
    } else {
      setUser({ nombre: '', apellido: '' });
    }
  }, []);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    navigate('/login');
  };

  return (
    <>
      {/* Right side - User profile and log out */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          padding: '5px 10px',
          borderRadius: '6px'
        }}
        onClick={handleProfileMenuOpen}
      >
        <Avatar alt="User" src="/mock-profile.jpg" sx={{ marginRight: 1 }} />
        <Typography variant="h6" noWrap>
          {user.nombre || user.apellido
            ? `Hola, ${user.nombre} ${user.apellido}`.trim()
            : "Hola"}
        </Typography>
      </Box>

      {/* Profile Menu Dropdown */}
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleLogout}>
          <LogoutIcon sx={{ marginRight: 1 }} />
          Cerrar Sesión
        </MenuItem>
      </Menu>
    </>
  );
};

export default ProfileMenu;
